import React, {ForwardedRef, forwardRef, useCallback, useContext, useImperativeHandle, useState} from 'react';
import {ResponseData} from '@dvrd/dvr-controls';
import {ActivateHandle} from '../../../util/interfaces';
import {addSearchRankingKeyword} from '../../../util/requestSender';
import {AppContext} from '../../misc/appContext';
import AddKeywords from './addKeywords';
import {showSnackbar} from '@dvrd/dvr-controls';
import {useTranslation} from 'react-i18next';

interface Props {
    onSuccess: VoidFunction;
    onOpenImport: VoidFunction;
}

function AddKeywordsController(props: Props, ref: ForwardedRef<ActivateHandle>) {
    const {account} = useContext(AppContext).accountContext;
    const {t} = useTranslation();
    const {onSuccess, onOpenImport} = props;

    const [active, setActive] = useState(false);
    const [ean, setEan] = useState('');
    const [keyword, setKeyword] = useState('');
    const [loading, setLoading] = useState(false);

    const onActivate = useCallback((params?: string) => {
        setActive(true);
        if (params) setEan(params);
    }, []);

    const onClose = useCallback(() => {
        setActive(false);
        setEan('');
        setKeyword('');
        setLoading(false);
    }, []);

    const onSubmit = useCallback(() => {
        if (!account || !ean.trim() || !keyword.trim()) return;
        setLoading(true);
        addSearchRankingKeyword({
            data: {
                account_id: account.id,
                ean: ean.trim(),
                keyword: keyword.trim()
            },
            callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    showSnackbar(t('searchRankings.addKeywords.snackbarAdded', 'Keyword toegevoegd'));
                    onSuccess();
                    onClose();
                } else {
                    showSnackbar(data.message || t('searchRankings.addKeywords.snackbarError', 'Er is iets misgegaan'));
                }
            }
        });
    }, [account, ean, keyword, onSuccess, onClose]);

    const onBulkImport = useCallback(() => {
        onClose();
        onOpenImport();
    }, [onClose, onOpenImport]);

    useImperativeHandle(ref, () => ({
        activate: onActivate
    }));

    return (
        <AddKeywords
            active={active}
            onClose={onClose}
            keyword={keyword}
            onChangeKeyword={setKeyword}
            onSubmit={onSubmit}
            loading={loading}
            onBulkImport={onBulkImport}
        />
    );
}

export default forwardRef<ActivateHandle, Props>(AddKeywordsController);
